<gwo-layout [name]="title">
    <router-outlet />
</gwo-layout>
